<template>
	<div class="">
		<div class="d-flex flex-column gap-3 mb-5">
			<calculator_input_value_single @update="setSalary" @brutto="setBrutto" defaultCurrency="CHF" />
			<calculator_output_period @update="setPeriodMonth" />
		</div>

		<h5 class="mb-4 fwc-bold">{{ pll["My net income would be"] }}</h5>
		<calculator_output_currency class="bold-value" currency="CHF" />

		<span v-if="brutto">
			<title_value class="mb-3 tv-bold" :title="pll['Gross Income']" :value="salary" />

			<div class="d-flex flex-column gap-1">
				<title_value class="tv-bold mt-1" :title="pll['Total taxes']" pre="-" :value="total_expenses" />
				<small role="button" v-if="!spoiler" @click="spoiler = !spoiler" class="d-block text-muted"> {{ pll["Show taxes"] }} → </small>
				<div v-if="spoiler">
					<title_value :title="pll['AVS']" pre="-" :value="avs" />
					<title_value :title="pll['AC']" pre="-" :value="ac" />
					<title_value :title="pll['Amat']" pre="-" :value="amat" />
					<title_value :title="pll['LPP']" pre="-" :value="lpp" />
					<title_value :title="pll['Maladie']" pre="-" :value="maladie" />
					<title_value :title="pll['LAA Non-prof']" pre="-" :value="laa" />
					<title_value :title="pll['Withholding income tax']" pre="-" :value="withholding" />
				</div>
			</div>
			<!-- Output summ brutto -->
			<title_value class="fwc-bold mt-3" :title="pll['Summ']" :value="month_period * total_net_income" />
			<!-- </div> -->
		</span>

		<!-- Output summ netto -->
		<title_value v-else class="fwc-bold mt-3" :title="pll['Summ']" :value="month_period * salary" />
	</div>
</template>
<script>
import title_value from "./inc/title_value";
import custom_select from "./inc/custom_select";
import calculator_input_value_single from "./inc/calculator_input_value_single";
import calculator_output_currency from "./inc/calculator_output_currency";
import calculator_output_period from "./inc/calculator_output_period";
import currencies from "./mixins/currencies";
import personal_tax_ch from "./mixins/personal_tax_ch";

export default {
	components: {
		title_value,
		custom_select,
		calculator_input_value_single,
		calculator_output_currency,
		calculator_output_period,
	},
	mixins: [currencies, personal_tax_ch],
	data() {
		return {
			salary: null,
			max_base: 3428,
			month_period: null,
			spoiler: false,
			brutto: true,
		};
	},
	beforeMount() {
		this.$store.commit("currency_for_calculate_taxes", "CHF");
	},
	computed: {
		// Base with condition max base
		base: function () {
			if (this.salary <= 1792) {
				return 0;
			} else if (this.salary <= 2390) {
				return 3585 / 12;
			} else if (this.salary <= 7170) {
				return this.salary - 2091.25;
			} else {
				return 0;
			}
		},
		// AVS
		avs: function () {
			return this.salary * 0.053;
		},
		// AC
		ac: function () {
			return this.salary * 0.011;
		},
		// Amat
		amat: function () {
			return this.salary * 0.00043;
		},
		// LPP
		lpp: function () {
			return this.base * 0.06;
		},
		// Maladie
		maladie: function () {
			return this.salary * 0.0256;
		},
		// LAA Non-prof
		laa: function () {
			return this.salary * 0.0156;
		},
		// Personal tax
		personal_tax: function () {
			if (this.salary <= 7100) {
				let array_taxes = this.personal_tax_ch,
					personal = array_taxes.filter((element) => this.salary <= element.to);
				if (personal.length > 0) {
					return personal[0].procent;
				}
			}
			return 14.34;
		},
		// Withholding income tax
		withholding: function () {
			return this.salary * (this.personal_tax / 100);
		},
		// Total Expenses
		total_expenses: function () {
			return this.avs + this.ac + this.amat + this.lpp + this.maladie + this.laa + this.withholding;
		},
		// Total net income
		total_net_income: function () {
			return this.salary - this.total_expenses;
		},
	},
	methods: {
		setBrutto(val) {
			this.brutto = val;
		},
		setPeriodMonth(val) {
			this.month_period = val;
		},
		setSalary(val) {
			this.salary = val;
		},
	},
};
</script>
